import { render } from "./search-filter.vue?vue&type=template&id=a2c131a4"
import script from "./search-filter.vue?vue&type=script&lang=js"
export * from "./search-filter.vue?vue&type=script&lang=js"

import "./search-filter.vue?vue&type=style&index=0&id=a2c131a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__